var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"position":"relative","top":"10px"}},[_c('i',{staticClass:"el-icon-back",staticStyle:{"font-size":"30px","cursor":"pointer"},on:{"click":function($event){return _vm.back()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }